import ActionNames from '../../actions/names';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: false,
  data: [],
  error: null,
});

function MCOsReducer(state=initialState, action) {
  switch(action.type) {
    case ActionNames.REQUEST_RUM_MCOS: 
      return state.merge({data: [], loading: true, charts: {}});
    case ActionNames.RECEIVE_RUM_MCOS: 
      return state.merge({data: action.data, loading: false, charts: action.charts})
    case ActionNames.FAILURE_RUM_MCOS: 
      return state.merge({error: action.error, loading: false, charts: {}})

    case ActionNames.REQUEST_CHARTS_MCOS: {
      const charts = Object.assign({}, state.charts, { [action.name]: { loading: true, data: [] }})
      return state.merge({charts});
    }
    case ActionNames.RECEIVE_CHARTS_MCOS: {
      const chart = Object.assign({}, {loading: false}, action.data);
      const charts = Object.assign({}, state.charts, { [action.name]: chart });
      return state.merge({charts});
    }
    case ActionNames.FAILURE_CHARTS_MCOS: {
      const charts = Object.assign({}, state.charts, { [action.name]: { loading: false, data: [] }})
      return state.merge({charts});
    }
    default: 
      return state;
  }
}

export default MCOsReducer;